// Branch GraphQL Queries to Get, Create, Update, Delete 

import { useRequestGQLQuery } from "./useGraphQLQuery";


export const GQL_VARMAPS_BY_NAMESPACE = `  varmaps(where: {_or: $objectConditions}, order_by: {variable_name: asc}) {
  variable_name
  value_path
  updated_at
  type_meta
  static_value
  object_meta
  metadata
  id
  created_at
}`

export const GQL_VARMAPS_ALL = `varmaps(order_by: {variable_name: asc}) {
  variable_name
  value_path
  updated_at
  type_meta
  static_value
  object_meta
  metadata
  id
  created_at
}`

export const GQL_VARMAPS_SHORT_BY_NAMESPACE = `varmaps(where: {_or: $objectConditions}, order_by: {variable_name: asc}) {
  variable_name
  static_value
  id
}`

/**
 * Query to get varmaps of multiple namespaces like Global and Site's namespace
 */
export const GQL_VARMAPS_SEARCH = `query getVarmaps($limit: Int!, $offset: Int!, $name: String, $objectConditions: [varmaps_bool_exp!]) {
  varmaps(where: {_or: $objectConditions,  _or: [{variable_name: {_ilike: $name}}] }, offset: $offset, limit: $limit, order_by: {created_at: desc, variable_name: desc}) {
    variable_name
    updated_at
    object_meta
    metadata
    id
    created_at
  }
  varmaps_aggregate(where: {_or: $objectConditions ,_or: [{variable_name: {_ilike: $name}] }) {
    aggregate {
      count
    }
  }
}`;


  export const CREATE_OR_UPDATE_VARMAPS = `mutation createOrUpdateVarMaps($data: [varmaps_insert_input!]!) {
    insert_varmaps(objects: $data, on_conflict: {constraint: varmaps_pkey, update_columns: [variable_name, static_value, value_path, metadata, object_meta, updated_at]}) {
        returning {
          variable_name
          value_path
          updated_at
          type_meta
          static_value
          object_meta
          metadata
          id
          created_at
        }
      }
    }`

export const UPDATE_STATIC_VALUE_VARMAPS = `mutation updateVarMaps($uid: bigint!, $data: varmaps_set_input!) {
      update_varmaps(where:{id:{_eq: $uid}}, _set: $data) {
          returning {
            variable_name
            static_value
            id
          }
        }
      }`


export const DELETE_VARMAP = `mutation deleteVarMaps($uid: bigint) {
    delete_varmaps(where: {id: {_eq: $uid} }) {
    affected_rows
    }
  }`


  export const GQLGetVarMapsSearch = (variables: any) => {
    const result = useRequestGQLQuery(GQL_VARMAPS_SEARCH, variables);
    return result;
  };


    export const GQLUpsertVarMaps = (branch: any) => {
  const result = useRequestGQLQuery(CREATE_OR_UPDATE_VARMAPS, { data: [branch] });
  return result;
};